import { useState, useEffect, useRef } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink, useNavigate, NavLink, useParams, useLocation } from 'react-router-dom';
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import * as React from 'react';
// @mui
import { styled } from '@mui/material/styles';
import { Button, Typography, Container, Box, Modal } from '@mui/material';
import config from "../../config";
import { encryptData } from '../../utils/cryptoUtils';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import "bootstrap-icons/font/bootstrap-icons.css";
import '../common.scss';
import * as userActions from "../../actions/userActions";
import AccessDenied from '../common/AccessDenied';
import * as leadBankStatementActions from "../../actions/leadBankStatementActions";
import * as leadActions from "../../actions/leadActions";
// ----------------------------------------------------------------------
const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));
// ----------------------------------------------------------------------
const CamBureauPage = (props) => {
  const { leadId, id } = useParams();
  const location = useLocation();
  const {leadInfo, actions, usersData, fetchLeadIdBankStatement,crifDetails } = props;
  const { register, handleSubmit, formState: { errors }, setValue, reset } = useForm();
  const navigate = useNavigate(); 
  const [isInitialized, setIsInitialized] = useState(false);
  const [crifAccountInformationArr, setCrifAccountInformationArr] = useState([]);
   

  const [formCAMValues, setFormCAMValues] = useState({
    addressTypeId: '1'
  });
  
    
  useEffect(() => { 
    const crifAccountInformation = crifDetails?.account_information || [];  
      setCrifAccountInformationArr(crifAccountInformation);
      setIsInitialized(true); // Add a flag to prevent re-execution  
      // console.log("crifAccountInformation = ", crifAccountInformation);
     
  }, [crifDetails, isInitialized]);


  return (
    <>
      <div id="main-wrap" className='mt-4 cam_section'>
        <div className='row justify-content-between'>
          <div className="row">
            <div className='col-md-12'>
              <h5>Bureau</h5>

              <table border="1" className="table">
              <thead>
                <tr>
                    <th>Customer / Co applicant / Entity Name</th>		
                    <th>Financer (Best Effort)</th>	
                    <th>Account Type / Type of loan</th>		
                    <th>Opened Date	</th>	
                    <th>Last reported Date</th>	
                    <th>Loan Amount(₹)	</th>	
                    <th>Current Balance / POS(₹)</th>		
                    <th>EMI (₹)</th>							
                    <th>Owneship	</th>	
                    <th>Status</th>		
                    <th>Settlment Amt</th>		
                    <th>Overdue	</th>	
                    <th>Pricipal W/o amt	</th>	
                    <th>Total W/o amt</th>	
                  </tr>
                </thead>
                <tbody>
                {crifAccountInformationArr.map((row, index) => (
                   <tr key={index}>
                  
                      <td>{row.customer_name}</td>
                      <td>&nbsp;</td>
                      <td>{row.acc_type}</td>
                      <td>{row.last_paid_date}</td>
                      <td>{row.total_writeoff_amt}</td>
                      <td>{row.disbursed_amt}</td>
                      <td>{row.current_balance}</td>
                      <td>{row.instl_amt_freq}</td>
                      <td>{row.ownership}</td>
                      <td>{row.status}</td>
                      <td>{row.settlement_amt}</td>
                      <td>{row.overdue_amt}</td>
                      <td>{row.principal_writeoff_amt}</td>
                      <td>{row.total_writeoff_amt}</td> 

                  </tr>
                    ))}

                </tbody>

                </table>
            </div>
          </div>
         </div>
      </div>
    </>
  );
}


function mapStateToProps(state) {
  return {
    usersData: state.usersData,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign(userActions.default, leadBankStatementActions.default, leadActions.default), dispatch),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(CamBureauPage);
